import ScrollRestoration from './ScrollRestoration';

export default ScrollRestoration;
